// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  CreateBookingRequest,
  CreateSlotsRequest,
  GenericApiResponseAppointmentSlot,
  GenericApiResponseBooking,
  GenericApiResponseDictStrStr,
  GenericApiResponseDictStrUnionStrNoneType,
  GenericApiResponseListAppointmentSlot,
  GenericApiResponseListBooking,
  GetLecturerSlotsParams,
  GetUserBookingsParams,
  HTTPValidationError,
  RescheduleSlotRequest,
  SetBookingAdmissionRequest,
} from '../../models';

/**
 * Create appointment slots with bindings.

This endpoint allows lecturers to create time slots that can be used
by multiple tasks/modules based on the binding configuration.
 * @summary Create Appointment Slots
 */
export const createAppointmentSlots = (
  createSlotsRequest: CreateSlotsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListAppointmentSlot>> => {
  return axios.post(`/appointments/slots`, createSlotsRequest, options);
};

export const getCreateAppointmentSlotsMutationOptions = <
  TData = Awaited<ReturnType<typeof createAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CreateSlotsRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createAppointmentSlots'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAppointmentSlots>>,
    { data: CreateSlotsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createAppointmentSlots(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: CreateSlotsRequest },
    TContext
  >;
};

export type CreateAppointmentSlotsMutationResult = NonNullable<Awaited<ReturnType<typeof createAppointmentSlots>>>;
export type CreateAppointmentSlotsMutationBody = CreateSlotsRequest;
export type CreateAppointmentSlotsMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create Appointment Slots
 */
export const useCreateAppointmentSlots = <
  TData = Awaited<ReturnType<typeof createAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CreateSlotsRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: CreateSlotsRequest }, TContext> => {
  const mutationOptions = getCreateAppointmentSlotsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get all slots for a lecturer.

If lecturer_id is not provided, returns slots for the current user.
 * @summary Get Lecturer Slots
 */
export const getLecturerSlots = (
  params?: GetLecturerSlotsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListAppointmentSlot>> => {
  return axios.get(`/appointments/slots`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetLecturerSlotsQueryKey = (params?: GetLecturerSlotsParams) => {
  return [`/appointments/slots`, ...(params ? [params] : [])] as const;
};

export const getGetLecturerSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLecturerSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetLecturerSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLecturerSlotsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLecturerSlots>>> = ({ signal }) =>
    getLecturerSlots(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLecturerSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLecturerSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof getLecturerSlots>>>;
export type GetLecturerSlotsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetLecturerSlots<
  TData = Awaited<ReturnType<typeof getLecturerSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetLecturerSlotsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLecturerSlots<
  TData = Awaited<ReturnType<typeof getLecturerSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetLecturerSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLecturerSlots<
  TData = Awaited<ReturnType<typeof getLecturerSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetLecturerSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Lecturer Slots
 */

export function useGetLecturerSlots<
  TData = Awaited<ReturnType<typeof getLecturerSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetLecturerSlotsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLecturerSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLecturerSlotsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single appointment slot by id for the owning lecturer (or admin).
 * @summary Get Appointment Slot
 */
export const getAppointmentSlot = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAppointmentSlot>> => {
  return axios.get(`/appointments/slots/${slotId}`, options);
};

export const getGetAppointmentSlotQueryKey = (slotId: string) => {
  return [`/appointments/slots/${slotId}`] as const;
};

export const getGetAppointmentSlotQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentSlotQueryKey(slotId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentSlot>>> = ({ signal }) =>
    getAppointmentSlot(slotId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!slotId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppointmentSlot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAppointmentSlotQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentSlot>>>;
export type GetAppointmentSlotQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAppointmentSlot<
  TData = Awaited<ReturnType<typeof getAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentSlot<
  TData = Awaited<ReturnType<typeof getAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAppointmentSlot<
  TData = Awaited<ReturnType<typeof getAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Appointment Slot
 */

export function useGetAppointmentSlot<
  TData = Awaited<ReturnType<typeof getAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentSlot>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentSlotQueryOptions(slotId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cancel an appointment slot.

Only the lecturer who created the slot can cancel it.
 * @summary Cancel Appointment Slot
 */
export const cancelAppointmentSlot = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAppointmentSlot>> => {
  return axios.delete(`/appointments/slots/${slotId}`, options);
};

export const getCancelAppointmentSlotMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['cancelAppointmentSlot'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAppointmentSlot>>, { slotId: string }> = (
    props,
  ) => {
    const { slotId } = props ?? {};

    return cancelAppointmentSlot(slotId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { slotId: string }, TContext>;
};

export type CancelAppointmentSlotMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAppointmentSlot>>>;

export type CancelAppointmentSlotMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Cancel Appointment Slot
 */
export const useCancelAppointmentSlot = <
  TData = Awaited<ReturnType<typeof cancelAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string }, TContext> => {
  const mutationOptions = getCancelAppointmentSlotMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Manually confirm an appointment slot (mark as available). Only for slot owner or admin.
 * @summary Confirm Appointment Slot
 */
export const confirmAppointmentSlot = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAppointmentSlot>> => {
  return axios.post(`/appointments/slots/${slotId}/confirm`, undefined, options);
};

export const getConfirmAppointmentSlotMutationOptions = <
  TData = Awaited<ReturnType<typeof confirmAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['confirmAppointmentSlot'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAppointmentSlot>>, { slotId: string }> = (
    props,
  ) => {
    const { slotId } = props ?? {};

    return confirmAppointmentSlot(slotId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { slotId: string }, TContext>;
};

export type ConfirmAppointmentSlotMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAppointmentSlot>>>;

export type ConfirmAppointmentSlotMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Confirm Appointment Slot
 */
export const useConfirmAppointmentSlot = <
  TData = Awaited<ReturnType<typeof confirmAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string }, TContext> => {
  const mutationOptions = getConfirmAppointmentSlotMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Reschedule an appointment slot to a new start time.

Non-cancelled bookings keep their ids and status; their times move with the slot.
Only the lecturer who owns the slot may reschedule it.
 * @summary Reschedule Appointment Slot
 */
export const rescheduleAppointmentSlot = (
  slotId: string,
  rescheduleSlotRequest: RescheduleSlotRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAppointmentSlot>> => {
  return axios.patch(`/appointments/slots/${slotId}/reschedule`, rescheduleSlotRequest, options);
};

export const getRescheduleAppointmentSlotMutationOptions = <
  TData = Awaited<ReturnType<typeof rescheduleAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; data: RescheduleSlotRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['rescheduleAppointmentSlot'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rescheduleAppointmentSlot>>,
    { slotId: string; data: RescheduleSlotRequest }
  > = (props) => {
    const { slotId, data } = props ?? {};

    return rescheduleAppointmentSlot(slotId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: RescheduleSlotRequest },
    TContext
  >;
};

export type RescheduleAppointmentSlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescheduleAppointmentSlot>>
>;
export type RescheduleAppointmentSlotMutationBody = RescheduleSlotRequest;
export type RescheduleAppointmentSlotMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reschedule Appointment Slot
 */
export const useRescheduleAppointmentSlot = <
  TData = Awaited<ReturnType<typeof rescheduleAppointmentSlot>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; data: RescheduleSlotRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string; data: RescheduleSlotRequest }, TContext> => {
  const mutationOptions = getRescheduleAppointmentSlotMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get available appointment slots for a task.

Returns only future slots that have available capacity and match
the task's binding requirements.
 * @summary Get Available Slots
 */
export const getAvailableAppointmentSlots = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListAppointmentSlot>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/appointment-slots`, options);
};

export const getGetAvailableAppointmentSlotsQueryKey = (courseId: string, moduleId: string, taskId: string) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/appointment-slots`] as const;
};

export const getGetAvailableAppointmentSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableAppointmentSlotsQueryKey(courseId, moduleId, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>> = ({ signal }) =>
    getAvailableAppointmentSlots(courseId, moduleId, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableAppointmentSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableAppointmentSlots>>
>;
export type GetAvailableAppointmentSlotsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAvailableAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Available Slots
 */

export function useGetAvailableAppointmentSlots<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlots>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlots>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailableAppointmentSlotsQueryOptions(courseId, moduleId, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get available appointment slots for a task using module context.

This endpoint resolves the course context automatically for students
based on their enrollment in courses containing the module.
 * @summary Get Available Slots By Module
 */
export const getAvailableAppointmentSlotsByModule = (
  moduleId: string,
  version: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListAppointmentSlot>> => {
  return axios.get(`/modules/${moduleId}/versions/${version}/tasks/${taskId}/appointment-slots`, options);
};

export const getGetAvailableAppointmentSlotsByModuleQueryKey = (moduleId: string, version: string, taskId: string) => {
  return [`/modules/${moduleId}/versions/${version}/tasks/${taskId}/appointment-slots`] as const;
};

export const getGetAvailableAppointmentSlotsByModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableAppointmentSlotsByModuleQueryKey(moduleId, version, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>> = ({ signal }) =>
    getAvailableAppointmentSlotsByModule(moduleId, version, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && version && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableAppointmentSlotsByModuleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>
>;
export type GetAvailableAppointmentSlotsByModuleQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAvailableAppointmentSlotsByModule<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableAppointmentSlotsByModule<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableAppointmentSlotsByModule<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Available Slots By Module
 */

export function useGetAvailableAppointmentSlotsByModule<
  TData = Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAppointmentSlotsByModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailableAppointmentSlotsByModuleQueryOptions(moduleId, version, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Book an appointment slot for an event task.

Students can book available slots for event tasks. The booking will include
placeholder information for Teams meeting creation which requires tenant
Graph API configuration.
 * @summary Create Booking
 */
export const createBooking = (
  courseId: string,
  moduleId: string,
  taskId: string,
  createBookingRequest: CreateBookingRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBooking>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings`, createBookingRequest, options);
};

export const getCreateBookingMutationOptions = <
  TData = Awaited<ReturnType<typeof createBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: CreateBookingRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createBooking'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBooking>>,
    { courseId: string; moduleId: string; taskId: string; data: CreateBookingRequest }
  > = (props) => {
    const { courseId, moduleId, taskId, data } = props ?? {};

    return createBooking(courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: CreateBookingRequest },
    TContext
  >;
};

export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>;
export type CreateBookingMutationBody = CreateBookingRequest;
export type CreateBookingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create Booking
 */
export const useCreateBooking = <
  TData = Awaited<ReturnType<typeof createBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: CreateBookingRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: CreateBookingRequest },
  TContext
> => {
  const mutationOptions = getCreateBookingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get all bookings for a user.

Users can view their own bookings. Admins can view any user's bookings.
 * @summary Get User Bookings
 */
export const getUserBookings = (
  userId: string,
  params?: GetUserBookingsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListBooking>> => {
  return axios.get(`/users/${userId}/bookings`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetUserBookingsQueryKey = (userId: string, params?: GetUserBookingsParams) => {
  return [`/users/${userId}/bookings`, ...(params ? [params] : [])] as const;
};

export const getGetUserBookingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  params?: GetUserBookingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserBookingsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBookings>>> = ({ signal }) =>
    getUserBookings(userId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBookings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBookings>>>;
export type GetUserBookingsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUserBookings<
  TData = Awaited<ReturnType<typeof getUserBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  params: undefined | GetUserBookingsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserBookings<
  TData = Awaited<ReturnType<typeof getUserBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  params?: GetUserBookingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserBookings<
  TData = Awaited<ReturnType<typeof getUserBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  params?: GetUserBookingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Bookings
 */

export function useGetUserBookings<
  TData = Awaited<ReturnType<typeof getUserBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  params?: GetUserBookingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserBookingsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Manually confirm a booking. Only for booking owner or admin.
 * @summary Confirm Booking
 */
export const confirmBooking = (
  userId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBooking>> => {
  return axios.post(`/users/${userId}/bookings/${bookingId}/confirm`, undefined, options);
};

export const getConfirmBookingMutationOptions = <
  TData = Awaited<ReturnType<typeof confirmBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['confirmBooking'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmBooking>>,
    { userId: string; bookingId: string }
  > = (props) => {
    const { userId, bookingId } = props ?? {};

    return confirmBooking(userId, bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; bookingId: string },
    TContext
  >;
};

export type ConfirmBookingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmBooking>>>;

export type ConfirmBookingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Confirm Booking
 */
export const useConfirmBooking = <
  TData = Awaited<ReturnType<typeof confirmBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; bookingId: string }, TContext> => {
  const mutationOptions = getConfirmBookingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancel a booking.

Students can cancel a booking at least 24 hours before it starts, and that does not use an attempt.
Cancelling an oral exam less than 24 hours before the start counts as a failed attempt without a grade.
Other appointments still cannot be cancelled inside 24 hours.
 * @summary Cancel Booking
 */
export const cancelBooking = (
  userId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBooking>> => {
  return axios.delete(`/users/${userId}/bookings/${bookingId}`, options);
};

export const getCancelBookingMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['cancelBooking'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelBooking>>,
    { userId: string; bookingId: string }
  > = (props) => {
    const { userId, bookingId } = props ?? {};

    return cancelBooking(userId, bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; bookingId: string },
    TContext
  >;
};

export type CancelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBooking>>>;

export type CancelBookingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Cancel Booking
 */
export const useCancelBooking = <
  TData = Awaited<ReturnType<typeof cancelBooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; bookingId: string }, TContext> => {
  const mutationOptions = getCancelBookingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get all bookings for a specific slot.

The slot owner, co-supervisors on capacity>1 sittings, and admins may view
slot bookings.
 * @summary Get Slot Bookings
 */
export const getSlotBookings = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListBooking>> => {
  return axios.get(`/appointments/slots/${slotId}/bookings`, options);
};

export const getGetSlotBookingsQueryKey = (slotId: string) => {
  return [`/appointments/slots/${slotId}/bookings`] as const;
};

export const getGetSlotBookingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlotBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSlotBookingsQueryKey(slotId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlotBookings>>> = ({ signal }) =>
    getSlotBookings(slotId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!slotId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlotBookings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSlotBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSlotBookings>>>;
export type GetSlotBookingsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetSlotBookings<
  TData = Awaited<ReturnType<typeof getSlotBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSlotBookings<
  TData = Awaited<ReturnType<typeof getSlotBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSlotBookings<
  TData = Awaited<ReturnType<typeof getSlotBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Slot Bookings
 */

export function useGetSlotBookings<
  TData = Awaited<ReturnType<typeof getSlotBookings>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlotBookings>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSlotBookingsQueryOptions(slotId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set exam admission for a booking in one slot.

Allowed for the slot lecturer and admins.
 * @summary Set Booking Exam Admission
 */
export const setBookingExamAdmission = (
  slotId: string,
  bookingId: string,
  setBookingAdmissionRequest: SetBookingAdmissionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBooking>> => {
  return axios.patch(
    `/appointments/slots/${slotId}/bookings/${bookingId}/admission`,
    setBookingAdmissionRequest,
    options,
  );
};

export const getSetBookingExamAdmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof setBookingExamAdmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; bookingId: string; data: SetBookingAdmissionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['setBookingExamAdmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setBookingExamAdmission>>,
    { slotId: string; bookingId: string; data: SetBookingAdmissionRequest }
  > = (props) => {
    const { slotId, bookingId, data } = props ?? {};

    return setBookingExamAdmission(slotId, bookingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; bookingId: string; data: SetBookingAdmissionRequest },
    TContext
  >;
};

export type SetBookingExamAdmissionMutationResult = NonNullable<Awaited<ReturnType<typeof setBookingExamAdmission>>>;
export type SetBookingExamAdmissionMutationBody = SetBookingAdmissionRequest;
export type SetBookingExamAdmissionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Set Booking Exam Admission
 */
export const useSetBookingExamAdmission = <
  TData = Awaited<ReturnType<typeof setBookingExamAdmission>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; bookingId: string; data: SetBookingAdmissionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; bookingId: string; data: SetBookingAdmissionRequest },
  TContext
> => {
  const mutationOptions = getSetBookingExamAdmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Receive Microsoft Graph change notifications for calendar events, calls (begin/end/roster), and transcripts.
 * @summary Teams Integration Webhook
 */
export const teamsIntegrationWebhook = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDictStrStr>> => {
  return axios.post(`/integrations/teams/webhook`, undefined, options);
};

export const getTeamsIntegrationWebhookMutationOptions = <
  TData = Awaited<ReturnType<typeof teamsIntegrationWebhook>>,
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['teamsIntegrationWebhook'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsIntegrationWebhook>>, void> = () => {
    return teamsIntegrationWebhook(axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, void, TContext>;
};

export type TeamsIntegrationWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof teamsIntegrationWebhook>>>;

export type TeamsIntegrationWebhookMutationError = AxiosError<void>;

/**
 * @summary Teams Integration Webhook
 */
export const useTeamsIntegrationWebhook = <
  TData = Awaited<ReturnType<typeof teamsIntegrationWebhook>>,
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, void, TContext> => {
  const mutationOptions = getTeamsIntegrationWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Receive LiveKit egress lifecycle webhooks for oral exam recordings.
 * @summary Livekit Egress Webhook
 */
export const livekitEgressWebhook = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDictStrStr>> => {
  return axios.post(`/integrations/livekit/egress`, undefined, options);
};

export const getLivekitEgressWebhookMutationOptions = <
  TData = Awaited<ReturnType<typeof livekitEgressWebhook>>,
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['livekitEgressWebhook'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof livekitEgressWebhook>>, void> = () => {
    return livekitEgressWebhook(axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, void, TContext>;
};

export type LivekitEgressWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof livekitEgressWebhook>>>;

export type LivekitEgressWebhookMutationError = AxiosError<void>;

/**
 * @summary Livekit Egress Webhook
 */
export const useLivekitEgressWebhook = <
  TData = Awaited<ReturnType<typeof livekitEgressWebhook>>,
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, void, TContext> => {
  const mutationOptions = getLivekitEgressWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Fetch a Teams meeting transcript by teamsMeetingId and append it to the student's task submission. This is a manual fallback; use when notifications are unavailable or delayed.
 * @summary Import Teams Meeting Transcript
 */
export const importTeamsMeetingTranscript = (
  teamsMeetingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDictStrUnionStrNoneType>> => {
  return axios.post(`/integrations/teams/meetings/${teamsMeetingId}/import-transcript`, undefined, options);
};

export const getImportTeamsMeetingTranscriptMutationOptions = <
  TData = Awaited<ReturnType<typeof importTeamsMeetingTranscript>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { teamsMeetingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['importTeamsMeetingTranscript'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importTeamsMeetingTranscript>>,
    { teamsMeetingId: string }
  > = (props) => {
    const { teamsMeetingId } = props ?? {};

    return importTeamsMeetingTranscript(teamsMeetingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { teamsMeetingId: string }, TContext>;
};

export type ImportTeamsMeetingTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof importTeamsMeetingTranscript>>
>;

export type ImportTeamsMeetingTranscriptMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Import Teams Meeting Transcript
 */
export const useImportTeamsMeetingTranscript = <
  TData = Awaited<ReturnType<typeof importTeamsMeetingTranscript>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { teamsMeetingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { teamsMeetingId: string }, TContext> => {
  const mutationOptions = getImportTeamsMeetingTranscriptMutationOptions(options);

  return useMutation(mutationOptions);
};
